
import { browserTests } from '../tests';

/**
 * @function getMapLinkForLocation
 * @description Direction lik with google for desktop otherwise fall back to address format that apple captures
 * see https://medium.com/@colinlord/opening-native-map-apps-from-the-mobile-browser-afd66fbbb8a4
 */
export const getMapLinkForLocation = (location) => {
	const encodedAddress = escape(location.address);
	const addressMobile = `maps://maps.google.com/maps?daddr=${location.lat},${location.lng}&amp;ll=`;
	const addressDesktop = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
	return (browserTests().ios) ? addressMobile : addressDesktop;
};

/**
 * @function getMapBounds
 * @description Return map bounds based on list of places. Uses map instance and google maps
 */
export const getMapBounds = (map, maps, locations) => {
	const bounds = new maps.LatLngBounds();

	locations.forEach((location) => {
		bounds.extend(new maps.LatLng(
			location.lat,
			location.lng,
		));
	});
	return bounds;
};

/**
 * @function getCenterOffset
 * @description Return map posaition with pixel offset. Uses map instance and google maps
 */
export const getCenterOffset = (map, maps, latlng, offsetx, offsety) => {
	var point1 = map.getProjection().fromLatLngToPoint(
		(latlng instanceof maps.LatLng) ? latlng : map.getCenter(),
	);
	var point2 = new maps.Point(
		( (typeof(offsetx) === 'number' ? offsetx : 0) / Math.pow(2, map.getZoom()) ) || 0,
		( (typeof(offsety) === 'number' ? offsety : 0) / Math.pow(2, map.getZoom()) ) || 0,
	);
	return map.getProjection().fromPointToLatLng(new maps.Point(
		point1.x - point2.x,
		point1.y + point2.y,
	));
};


// WEBPACK FOOTER //
// ./src/utils/data/location-toolbox.js